import { Component, ElementRef } from '@angular/core';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { RuleAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'sx-synccandidates-designer',
    templateUrl: './syncCandidatesDesigner.component.html'
})

export class SxSyncCandidatesDesigner extends BaseDesignerComponent {
   
    interactionRules: DesignerSelectItem[] = [];

    constructor(container: ElementRef) {
        super(container, 'SxSyncCandidates');
    }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.selectedOptionRule = '';
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();
        info['selectedOptionRule'] = this.controlContext.selectedOptionRule;
        return info;
    }
    
    buildAttributes(): void {
        this.interactionRules = this.designerContext.product.interactionRules;

        const selectedOptionRule =
            new RuleAttribute(this.controlContext, this.interactionRules , 'selectedOptionRule', 'Synchronization Candidates Rule');

        this.attributes.push(selectedOptionRule);
    }


}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/syncCandidatesDesigner.component.ts